import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/userActionReport'
import Component from 'components/Reports/UserActionReport'

export default createListViewContainer({ actions, selectors: selectors.userActionReport })(Component)
